module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-76x76-7d96360894900d8f6052f728c67d3722.png";